import React from 'react';
import OnVisible from 'react-on-visible';
const SkillsChart = () => (
    <div className="chart-wrapper">
        <OnVisible className="chart">
            <ul>
                <div className="gridline gridline-0"></div>
                <div className="gridline gridline-25"></div>
                <div className="gridline gridline-50"></div>
                <div className="gridline gridline-75"></div>
                <div className="gridline gridline-100"></div>
                <li className="axis">
                    <div className="label">Expert</div>
                    <div className="label">Advanced</div>
                    <div className="label">Intermediate</div>
                    <div className="label">Beginner</div>
                </li>
                <li className="html">
                    <div className="percent">
                        <span>90%</span>
                    </div>
                    <div className="skill">HTML & CSS</div>
                </li>
                <li className="js">
                    <div className="percent">
                        <span>80%</span>
                    </div>
                    <div className="skill">Javascript</div>
                </li>
                <li className="java">
                    <div className="percent">
                        <span>60%</span>
                    </div>
                    <div className="skill">Java</div>
                </li>
                <li className="swift">
                    <div className="percent">
                        <span>50%</span>
                    </div>
                    <div className="skill">Swift</div>
                </li>
                <li className="photoshop">
                    <div className="percent">
                        <span>70%</span>
                    </div>
                    <div className="skill">Photoshop</div>
                </li>
                <li className="sketch">
                    <div className="percent">
                        <span>50%</span>
                    </div>
                    <div className="skill">Git</div>
                </li>
            </ul>
        </OnVisible>
    </div>
);

export default SkillsChart;


// WEBPACK FOOTER //
// ./src/components/home/Skills/chart.js